export const state = () => ({
    childPageTitle: 'test'
})

export const mutations = {
    updateChildTitle(state, newTitle) {
        state.childPageTitle = newTitle
    },
}